import type { ReactNode } from 'react';
import { alert } from './Alert.css';

type Tone = 'danger' | 'success' | 'info';

export function Alert({
  tone = 'danger',
  children,
  className,
}: {
  tone?: Tone;
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={className ? `${alert[tone]} ${className}` : alert[tone]}
      data-tone={tone}
      role={tone === 'danger' ? 'alert' : undefined}
    >
      {children}
    </div>
  );
}
